import React, { useEffect, useRef } from "react"
import * as THREE from "three"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { useScene } from "../../hooks/useScene"

import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader"
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader"
import {
  DataTexture,
  Material,
  Mesh,
  MeshPhysicalMaterial,
  Object3D,
} from "three"

const Building = () => {
  const container = useRef<HTMLDivElement>(null)
  let controls: OrbitControls
  const { renderer, scene } = useScene({ container })

  useEffect(() => {
    setTimeout(() => {
      /* */
    }, 3000)
    const camera = new THREE.PerspectiveCamera(
      60,
      window.innerWidth / window.innerHeight,
      0.1,
      100000,
    )

    const group = new THREE.Group()
    group.scale.set(1, 1, 1)
    group.position.set(0, -7, 0)
    scene.add(group)

    controls = new OrbitControls(camera, renderer.domElement)
    controls.enablePan = true
    controls.enableDamping = true // an animation loop is required when either damping or auto-rotation are enabled
    controls.dampingFactor = 0.1
    controls.maxPolarAngle = Math.PI / 2
    controls.maxDistance = 15000
    camera.position.set(10000, 10000, 10000)

    const rgbeLoader = new RGBELoader()
    let texture = rgbeLoader.load(
      "textures/lightmaps/gtc-x_VII-sprat_lightmap_group_final.hdr",
      function (textureData: DataTexture) {
        texture = textureData
      },
    )

    console.log(texture)

    texture.wrapS = THREE.RepeatWrapping
    texture.wrapT = THREE.RepeatWrapping

    const loader = new FBXLoader()

    loader.load("models/gtc-x.FBX", (obj: Object3D) => {
      group.add(obj)
    })

    loader.load("models/gtc-x_camera.FBX", (obj: Object3D) => {
      controls.target = obj.position
      group.add(obj)
    })

    loader.load("models/gtc-x_interior-lights.FBX", (obj: Object3D) => {
      group.add(obj)
    })

    loader.load("models/gtc-x_env.FBX", (obj: any) => {
      obj.children.forEach(function (child: Mesh) {
        // const materials = child.material as Material[]
        if (
          child.material !== undefined &&
          (child.material as Material[]).length > 1
        ) {
          const materials: MeshPhysicalMaterial[] = []
          ;(child.material as Material[]).forEach(function (mat: Material) {
            const newaterial = new THREE.MeshPhysicalMaterial({
              clearcoat: 1.0,
              clearcoatRoughness: 0.1,
              metalness: 0.9,
              roughness: 0.5,
              lightMap: texture,
              color: 0xffffff,
            })
            newaterial.needsUpdate = true
            materials.push(newaterial)
          })
          child.material = materials
          console.log(child.material)
        } else {
          const newaterial = new THREE.MeshPhysicalMaterial({
            clearcoat: 1.0,
            clearcoatRoughness: 0.1,
            metalness: 0.9,
            roughness: 0.5,
            lightMap: texture,
            color: 0xffffff,
          })
          newaterial.needsUpdate = true
          child.material = newaterial
          console.log(child.material)
        }
      })
      group.add(obj)
    })

    const onPointerUp = (event: TouchEvent) => {
      const position = new THREE.Vector2(
        (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1,
        -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1,
      )
    }

    renderer.domElement.addEventListener("touchend", onPointerUp, false)

    window.addEventListener("resize", onWindowResize, false)

    function onWindowResize() {
      console.log("onresize")

      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()

      renderer.setSize(window.innerWidth, window.innerHeight)
    }

    controls.update()

    function animate() {
      requestAnimationFrame(animate)
      controls.update()
      renderer.render(scene as THREE.Scene, camera)
    }
    animate()
  }, [])

  return <div ref={container} className="App"></div>
}

export default Building
